<div [ngClass]="{'ng-invalid ng-dirty': isInvalid()}">
	<div class="d-flex">
		<ng-container *ngIf="!isMobile(); else mobileDropdownBtn">
			<p-dropdown
				#dropdownRef
				[options]="productsList"
				[optionLabel]="getProductNameProperty()"
				optionValue="product_id"
				[formControl]="control"
				[inputId]="label"
				placeholder="{{ 'documentLines.product' | translate }}"
				(onChange)="onDropdownChange($event)"
				[filter]="true"
				[filterBy]="'product_name_en,product_name_ar,product_name_he,catalog_id,price_per_unit,price_per_unit_before_vat,price,product_id,product_code' + getProductNameProperty()"
				[showClear]="false"
				[styleClass]="isInvalid() ? 'ng-invalid ng-dirty' : ''">
				<ng-template let-item pTemplate="item">
					<div style="font-size: 20px;">{{ getProductName(item) }}</div>
					<!-- <small style="font-size: 10px;color: gray;" class="fs-mini me-3" *ngIf="item?.product_id">ID: {{ item.product_id }}</small> -->
					<small style="font-size: 16px;color: gray;" *ngIf="item?.price">{{ item.price }}</small>
				</ng-template>
			</p-dropdown>
		</ng-container>
		<ng-template #mobileDropdownBtn>
			<button pButton type="button"
				[label]="control?.value ? getSelectedProductName() : ('documentLines.product' | translate)"
				icon="pi pi-chevron-down" class="flex-grow-1 justify-content-between" (click)="openMobileDropdown()"
				[disabled]="!isReady || (control?.disabled ?? false)">
			</button>
		</ng-template>
		<!-- <button pButton type="button" icon="pi pi-plus" class="flex-shrink-0 d-md-none" (click)="openAddProductModal()"
			[title]="'addProduct' | translate">
		</button> -->
		</div>
	<div *ngIf="isInvalid()" class="invalid-feedback text-danger d-block">
		{{ getErrorMessage() }}
	</div>
</div>

<p-dialog
	header="{{ 'addProduct' | translate }}"
	[(visible)]="isMobileDropdownOpen"
	[modal]="true"
	[baseZIndex]="1100"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{'768px': '100vw'}"
	[dismissableMask]="true"
	(onHide)="closeMobileDropdown()">
	<div class="mb-3 p-input-icon-right w-100">
		<i *ngIf="searchTerm" class="pi pi-times" (click)="searchTerm = ''"></i>
		<input #searchInput type="text" pInputText
		class="form-control w-100"
		[placeholder]="'form.field.product' | translate"
		[(ngModel)]="searchTerm"
		autocomplete="off"
		style="width: 100% !important;"
		/>
	</div>
	<div style="flex:1 1 auto; overflow-y:auto; max-height:70vh;">
		<div *ngFor="let item of filteredProducts" class="customer-list-item py-2 px-2 border-bottom"
			[ngClass]="{'bg-light': item.product_id === control?.value, 'customer-list-item-hover': true}"
			(click)="selectProduct(item)">
			<div>{{ getProductName(item) }}</div>
			<small class="fs-mini me-3" *ngIf="item?.price">₪{{ item.price }}</small>
			<small class="fs-mini" *ngIf="getProductDescription(item)">{{ getProductDescription(item) }}</small>
		</div>
		<div *ngIf="filteredProducts.length === 0" class="text-center text-muted py-4">
			{{ 'shared.customerSelect.noResults' | translate }}
		</div>
	</div>
	<ng-template pTemplate="footer">
		<button pButton type="button" class="mx-0 mt-3" icon="pi pi-plus" label="{{ 'addProduct' | translate }}"
			(click)="closeMobileDropdown(); openAddProductModal()"></button>
	</ng-template>
</p-dialog>

<p-dialog
	header="{{ 'routes.document.addProduct' | translate }}"
	[(visible)]="showAddProductModal"
	[modal]="true"
	[style]="{ width: 'min(96vw, 1280px)', 'min-width': '350px' }"
	[contentStyle]="{ maxHeight: 'min(88vh, 860px)', overflow: 'auto' }"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{'768px': '100vw'}"
	(onHide)="showAddProductModal=false">
	<app-add-product-modal *ngIf="showAddProductModal" [companyId]="companyId"
		(productAdded)="handleProductModalSave($event)" (cancel)="handleProductModalClose()">
	</app-add-product-modal>
</p-dialog>